module.exports = __webpack_public_path__ + "components/country-flag/static/be-f2b411dcef11ea8ec48403dabe8892c5.svg";